import { AvailableComponents } from "./Components";

export default function Hero({ config }) {
  const backgroundImage = window.screen.width > 920 ? "wide" : "mobile";

  const backgroundMode =
    config.background?.type === "IMAGE" && window.screen.width > 920;

  return (
    <div className={"hero " + (backgroundMode ? "hero-bg-mode" : "")}>
      {backgroundMode ? (
        <AvailableComponents.IMAGE
          config={{
            path: config.background[backgroundImage].path,
          }}
          className="hero-background-fill"
        />
      ) : (
        <div className="hero-bg-container">
          <AvailableComponents.IMAGE
            config={{
              path: config.background[backgroundImage].path,
            }}
            className="hero-background"
          />
        </div>
      )}

      <div className="hero-info">
        {config.content.map((content, i) => {
          const Component = AvailableComponents[content.type];
          if (!Component) return null;
          return <Component key={"component-" + i} config={content.settings} />;
        })}
      </div>
    </div>
  );
}
